import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import ZohoEntitySection from '@/components/zoho/ZohoEntitySection';
import ZohoEntityPeriodSelector from '@/components/zoho/ZohoEntityPeriodSelector';
import { groupFieldsIntoSections } from '@/components/zoho/fieldGrouping';

function pickSubmission(subs, periodField, periodValue) {
  if (!periodField || periodValue === '_latest') return subs[0];
  for (var i = 0; i < subs.length; i++) {
    var p = subs[i].raw_payload || {};
    if (String(p[periodField]) === periodValue) return subs[i];
  }
  return subs[0];
}

export default function EntityDetailView({ entity, form }) {
  var [period, setPeriod] = useState('_latest');
  var activeSub = pickSubmission(entity.submissions, form.period_field, period);
  var sections = groupFieldsIntoSections(activeSub.raw_payload || {});
  var receivedAt = activeSub.created_at ? new Date(activeSub.created_at).toLocaleString() : '';

  return (
    <div className="space-y-4" data-testid="entity-detail">
      <Card>
        <CardContent className="pt-4 pb-3 flex items-center justify-between flex-wrap gap-3">
          <div>
            <h2 className="text-lg font-bold">{entity.display_name || entity.primary_key}</h2>
            <p className="text-sm text-muted-foreground">
              {form.primary_key_field}: {entity.primary_key} | {entity.submission_count} submissions
            </p>
          </div>
          <ZohoEntityPeriodSelector
            periods={entity.periods}
            hasPeriods={entity.periods.length > 0 && !!form.period_field}
            value={period}
            onChange={setPeriod}
          />
        </CardContent>
      </Card>

      {sections.map(function(s) {
        return <ZohoEntitySection key={s.key} section={s} />;
      })}

      <div className="text-xs text-muted-foreground flex items-center gap-3 px-1">
        <span>ID: {activeSub.id}</span>
        <span>Received: {receivedAt}</span>
        <Badge variant="default" className="text-xs">{activeSub.processing_status}</Badge>
      </div>
    </div>
  );
}
